import { Box } from "@chakra-ui/react";
import CDS from "design-system";

interface CountBadgeProps {
  count: number;
  bg?: string;
  color?: string;
}

/** Small filled pill showing a count (e.g. a "5" notification badge). */
export default function CountBadge({ count, bg = "gray.700", color = "white" }: CountBadgeProps) {
  return (
    <Box
      minW="20px"
      h="20px"
      px={1.5}
      bg={bg}
      borderRadius="full"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      <CDS.Text12 fontWeight="bold" color={color} lineHeight="1">
        {count}
      </CDS.Text12>
    </Box>
  );
}
